import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './reservedCapacity.module.scss';

const ReservedCapacityGasHeader = () => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // render
  return (
    <div className={`d-none d-sm-block mb-2 text-muted font-weight-bold px-3`}>
      <div className="row no-gutters align-items-end">
        <div className={`col-sm-auto ${styles.periodCol} font-weight-bold`}>
          {tLabels("reservedCapacityGasHeader.timePeriod")} 
        </div>
        <div className="col-sm text-center">
          <span className="d-lg-none">{tLabels("reservedCapacityGasHeader.maxReservedCapacityShort")}</span>
          <span className="d-none d-lg-inline">{tLabels("reservedCapacityGasHeader.maxReservedCapacity")}</span> <small>[m<sup>3</sup>]</small>
        </div>
        <div className="col-sm text-center">
          {tLabels("reservedCapacityGasHeader.dailyReservedCapacity")} <small>[m<sup>3</sup>]</small>
        </div>
        <div className="col-sm text-center">
          {tLabels("reservedCapacityGasHeader.monthlyReservedCapacity")} <small>[m<sup>3</sup>]</small>
        </div>
        <div className={`col-sm text-center`}>
          {tLabels("reservedCapacityGasHeader.slidingCapacity")} <small>[m<sup>3</sup>]</small>
        </div>
        <div className={`col-sm text-center d-none d-lg-block`}>
          {tLabels("reservedCapacityGasHeader.dailyMax")} <small>[m<sup>3</sup>]</small>
        </div>
        <div className={`col-sm-auto text-center ${styles.typeCol}`}>
          {tLabels("reservedCapacityGasHeader.state")} 
        </div>
      </div>
    </div>
  )
}

export default ReservedCapacityGasHeader;